import { Component, OnInit, ElementRef, OnDestroy, ViewChild, ViewContainerRef, TemplateRef } from "@angular/core";
import { DatePipe } from "@angular/common";
import {
  FormControl,
  FormBuilder,
  Validators,
  FormArray,
  FormGroup, AbstractControl
} from "@angular/forms";

import { GridDataResult } from "@progress/kendo-angular-grid";
import { ISubscription } from "rxjs/Subscription";

import { AuthService } from "src/app/services/auth.service";
import { CommonMethods } from "src/app/services/common.method";
import { CommonService } from "@shared/services/common";
import { Constants } from "@shared/models/constants";
import { DataSharingLTE } from "@fs/services/data-sharing-lte";
import { JobSiteModel } from "src/app/fs-lte/models/customer/job-site-detail-model";
import { MaterialItemService } from "src/app/fs-lte/services/price-book/material-item/material-item.service";
import { PriceBucketModel } from "src/app/fs-lte/models/price-book/price-book.model";
import { PromisedTimeModel } from "@fs/models/promised-time.model";
import { ServiceItemService } from "src/app/fs-lte/services/price-book/service-item/service-item.service";
import { TabOpenService } from "src/app/services/tab-open.service";
import { Tabs } from "src/app/enums/tab.enum";
import { TimeZoneConverter } from "@shared/pipes/timezone-converter";
import {
  WorkOrderModel,
  ServiceType,
  Department,
  WorkTicketPriority,
  WorkTicketTechnician,
  WorkTicketPayment,
  WorkTicketDiscountItem,
  Discount,
  WorkTicketPaymentSummary,
  WorkTicketPriceBookItemEquipment, UserAppointment
} from "src/app/fs-lte/models/work-order/work-order.model";
import { WorkOrderService } from "@fs/services/work-order";
import { NotificationsService } from "@shared/services/notification";
import { groupBy, DataSourceRequestState } from "@progress/kendo-data-query";
import { KendoUploadFileInfo } from "@fs/components/price-book/material-item/material-create/material-create.component";
import { SuccessEvent, RemoveEvent, UploadEvent, CancelEvent, FileRestrictions } from "@progress/kendo-angular-upload";
import { Attachment } from "@fs/models/price-book/material-item.model";
import '@shared/interfaces/number-extention';
import { MultiSelectModel } from "@fs/models/equipment.model";
import { JobsiteEquipmentService } from '@fs/services/jobsite-equipment';
import { CodeTypes } from "src/app/fs-lte/enums/code-types.enum";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { LoaderType } from "@shared/enums/common";
import { ProductItemType } from "@fs/enums/common";
import { BillingDetailModel } from "@fs/models/customer/billing-detail.model";
import { WoBaseComponent } from "@fs/components/base/wo-base.component";
import { FsUtil } from "@fs/services/fs-utils";
import { of, Subject } from "rxjs";
import { catchError, debounceTime, switchMap, takeUntil, tap } from "rxjs/operators";
import { TemplateModel } from "@fs/models/template.model";
import { TabParams } from "@fs/services/tab-params.service";
@Component({
  selector: "app-work-order-edit",
  templateUrl: "./wo-edit.component.html",
  styleUrls: ["./wo-edit.component.scss"],
  providers: [TimeZoneConverter, DatePipe]
})
export class WorkOrderEditComponent extends WoBaseComponent implements OnInit, OnDestroy {
  // #region  Property Declaration
  private currentRemoveItemIndex: number = null;
  private currentRemoveTechIndex: number = null;
  private destroyTab: boolean = false;
  private minDate = new Date();
  private subscriptions: ISubscription[] = [];
  private tabCounter: number;
  private technicians: any = [];
  private techniciansData: Array<{ name: string, id: string, department: string }> = [];
  private techGroupedData: any[] = [];
  private inputParams: any;
  private workTicketItems: any = [];
  // #endregion

  // #region  Public Variables
  public balanceOwed = 0;
  public Details: any;
  public discountAmount = 0;
  public itemDropDownFilteredVals: any = [];
  public netTaxable: number;
  public taxedAmount = 0;
  public totalAmount = 0;
  public approvedPBItems: GridDataResult;
  public bucket: PriceBucketModel;
  public customDiscount: any;
  public customDiscountModal: boolean = false;
  public discounts: any;
  public editWorkTicketForm: FormGroup;
  public initialData: any;
  public messageRemoveItemConfirmation: string = "";
  public popupDiscountType: string = "";
  public primaryCustomerContact: any;
  public primaryJobSiteContact: any;
  public searchString: string = "";
  public selectedDiscount: WorkTicketDiscountItem;
  public selectedItems: any = [];
  public selectedTaxGroup: any;
  public showDeleteTechConfirmation: boolean;
  public showItemDeleteConfirmation: boolean;
  public taxGroups: any = [];
  public totalPaidDetails: GridDataResult;
  public totalTaxRate: any;
  public wtSelectedTaxGroup: any;
  public taxEditorPopup: boolean = false;
  public times = [];
  public customDiscountForm: FormGroup;
  public isFirstTechSelected: boolean = false;
  public isFirstTechRowCreated: boolean = false;
  public isUnsavedTriggered: boolean = false;
  public workTicketPayment: WorkTicketPaymentSummary;
  public isPriceBookWorkItemModified: boolean = false;
  public showModifyConfirmation: boolean = false;
  public modifyMessage: string ="";
  public estimatesConvertedTo: any;
  /* Kendo TimePicker */
  public steps: any = { hour: 1, minute: 30, second: 30 };
  public value: Date = new Date(2000, 1, 1, 10, 30);
  public format = "hh:mm a";
  public kendoUploadFileList: KendoUploadFileInfo[] = [];
  public modalOptions: { showAttachment: boolean } = { showAttachment: false };
  public attachmentType: string = "Image";
  public attachmentForm: FormGroup;
  public attachments: GridDataResult = { data: [], total: 0 };
  public isEditAttachment: boolean = false;
  public isUploadInProgress = false;
  public saveUrl: string = "";
  public showAttachmentSlider: boolean = false;
  public slideIndex: number = 0;
  public editAttachmentForm: FormGroup;
  public showDeleteConfirmation: boolean = false;
  public deleteDataItem: any;
  public deleteMessage: string = "";
  public uploadRestrictions: FileRestrictions = {
    allowedExtensions: Constants.DefaultFileExtension,
    maxFileSize: Constants.DefaultFileSize.inbytes
  };
  public allowedextensionsforAttachment: string = '';
  public allowedsizeforAttachment: number = 0;
  public previousUser: string;
  public isTaxEditable: boolean = false;
  public equipmentData: MultiSelectModel[] = [];
  public state: DataSourceRequestState = {
    skip: 0,
    take: -1,
    sort: [],
  };
  public customerAddress: string;
  public jobSiteAddress: string;
  public agreementDiscount = 0;
  public estimateItems: GridDataResult;

  /* Kendo TimePicker End */
  @ViewChild('tab4') tab4Ref: TemplateRef<any>;
  @ViewChild("editWorkTicket") editWorkTicket: ElementRef;
  @ViewChild("attachImagePreview") attachImagePreview: ElementRef;
  @ViewChild("attachmentUploadImageBtn") attachmentUploadImageBtn: ElementRef;
  @ViewChild("MIDropDown", {
    read: ViewContainerRef
  }) MIDropDown: ViewContainerRef;
  public showNoRecord: boolean = false;
  public itemType = ProductItemType;  
  public overrideItemIds = [];
  public activeAgreement: Boolean = false;
  public recalculateSpinner: Boolean = false;
  // #endregion
  // #region  LifeCycle Events
  constructor(
    private _elementRef: ElementRef,
    private auth: AuthService,
    private commonMethods: CommonMethods,
    private dataSharing: DataSharingLTE,
    private datePipe: DatePipe,
    private frmbuilder: FormBuilder,
    private httpCommon: CommonService,
    private httpMaterialItem: MaterialItemService,
    private httpService: WorkOrderService,
    private httpServiceItem: ServiceItemService,
    private tabOpen: TabOpenService,
    private toastr: NotificationsService,
    private equipmentService: JobsiteEquipmentService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef
  ) {
    super();
    this.allowedextensionsforAttachment = this.commonMethods.FileExtensionArrayToCommaSeparatedString(this.uploadRestrictions.allowedExtensions);
    this.allowedsizeforAttachment = Constants.DefaultFileSize.inMegabytes;
    this.registerSearch();
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.DestroySubscriptions();
  }
  ngOnInit() {
    this.initSubTabs();
    this.IncrementTime();
    this.minDate.setHours(0, 0, 0, 0);
    let subscription = this.dataSharing.OrderStatusChangeEvent.subscribe(response => {
      this.Details.Status = response.Status;
      this.Details.SubStatus = response.SubStatus;
    });
    this.subscriptions.push(subscription);
    this.IntializeForm(new WorkOrderModel());
    subscription = this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        this.SubmitForm();
      }
    });
    this.subscriptions.push(subscription);
    subscription = this.tabOpen.routeToParentEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter && response.event.split("|")[0] == "replaceTab" && response.event.split("|")[1] == "discard") {
        $(this._elementRef.nativeElement).find(".tabs__content__box").removeClass("dirty");
        setTimeout(() => {
          this.CloseTab();
        }, 300);
      } else if (response.tabCounter == this.tabCounter && response.event.split("|")[0] == "replaceTab" && response.event.split("|")[1] == "save") {
        this.SubmitForm();
      }
    });
    this.subscriptions.push(subscription);

    if (!FsUtil.checkNullOrUndefined([this.inputParams["activeSubTabIndex"]])) {
      FsUtil.selectTabStrip(this.subTabs, this.inputParams["activeSubTabIndex"]);
      if (this.inputParams["activeSubTabIndex"] == 2)
        this.InitSlider();
    }

    if (CommonMethods.CheckNullOrUndefined(this.inputParams.Status)) {
        this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
      subscription = this.httpService.GetWorkOrder(this.inputParams).subscribe(response => {
        this.LoadInitialData(response);
        this.saveUrl = this.httpService.GetAttachmentURL(this.inputParams.customerId, this.inputParams.jobsiteId, this.inputParams.ID);
      });
      this.subscriptions.push(subscription);

      this.subscriptions.push(this.equipmentService.GetEquipments({ customerId: this.inputParams.customerId, jobsiteId: this.inputParams.jobsiteId }, this.state).subscribe(response => {
        if (response != null) {
          this.equipmentData = response.Data;
        }
      }));
    } else {
      this.LoadInitialData(this.inputParams);
    }
    subscription = this.tabOpen.ChangeComponentEvent.subscribe(response => {
      if (response.removeSubscriptions != undefined) {
        if (response.removeSubscriptions) {
          this.DestroySubscriptions();
        }
      }
    })
    this.subscriptions.push(subscription);
  }
   viewEstimate(val) {
    let params = Object.assign({},val);
    params["Customer"] = { ID: params["CustomerID"] };
    params["JobSiteID"]= params.JobSite.ID;
    this.tabOpen.OpenTab({
      tabId: Tabs.EstimateDetail,
      params: params,
      tabTitle: val.EstimateNo == null ? " " : val.EstimateNo,
      replaceIfOpen: {
            replaceTab: true,
            tabToReplace: Tabs.EstimateEdit,
            action: "focus"
      }
    });
  }
  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.editWorkTicketForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }
  // #endregion

  // #region  Private Methods
  private InitSlider() {
    let intv = setInterval(() => {    
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
      if ($(this._elementRef.nativeElement).find(".discount__items").hasClass("slick-initialized")) {
        clearInterval(intv);      
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        return;
      }
      if (this.discounts != undefined && this.discounts.length > 0) {
        (<any>$(this._elementRef.nativeElement).find(".discount__items")).slick(
          {
            infinite: false,
            slidesToShow: 6,
            slidesToScroll: 6,
            nextArrow: $(".next"),
            prevArrow: $(".prev"),
            dots: true,
            responsive: [
              {
                breakpoint: 1580,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6
                }
              }
            ]
          }
        );
      } else if (this.discounts != undefined && this.discounts != null && this.discounts.length <= 0) {
        clearInterval(intv);
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        return;
      }
    }, 100);
  }
  private OptionalValidation(control: FormControl): any {
    if (control != undefined && control.parent != undefined) {
      if (control.parent.controls["User"].value != "") {
        if (control.value == "") {
          return { required: true };
        }
      }
    }
    return null;
  }
  private TimeValidation(control: FormControl): any {
    if (control != undefined && control.parent != undefined && control.parent.controls["StartTime"].value != ""
      && control.parent.controls["EndTime"].value != "") {
      let objStartTime = control.parent.controls["StartTime"].value
      let objEndTime = control.parent.controls["EndTime"].value
      if (objStartTime == null && objEndTime == null) {
        return null;
      }
      else if (objStartTime >= objEndTime) {
        return { InvalidTime: true };
      }
    }
    return null;
  }

  public HelpersForm = new FormArray([]);

  private CreateForm(data: any, IsPrimaryTech: boolean, scheduletype: string = '1', isPromiseTimeExistsInList: boolean = false): FormGroup {
    if (scheduletype == '2') {
      let promisedate: Date = new Date(data.PromisedDate);
      let DurationHour: number = CommonMethods.CheckNullOrUndefined(data.Duration) ? 0 : parseInt(data.Duration.toString().split(":")[0]);
      let DurationMin: string = CommonMethods.CheckNullOrUndefined(data.Duration) ? '00' : (data.Duration.toString().split(":")[1]);
      let Duration: string = DurationHour.toString() + ":" + DurationMin.toString() + ":00";

      let TechnicianFormRow = new FormGroup({
        ID: new FormControl(CommonMethods.GetID()),
        HelperId: new FormControl(CommonMethods.GetID()),
        Name: new FormControl(''),
        Date: new FormControl(promisedate, [Validators.required, this.CustomDateValidator]),
        PromisedTime: new FormControl(data.PromisedTime != null && isPromiseTimeExistsInList ? data.PromisedTime.ID : "", Validators.required),
        StartTime: new FormControl(promisedate),
        DurationHour: new FormControl(DurationHour, [Validators.required, this.DurationValidator]),
        DurationMin: new FormControl(DurationMin, [Validators.required, this.DurationValidator]),
        Duration: new FormControl(Duration, Validators.required),
        Dirty: new FormControl(true),
        autoschedule: new FormControl(false),
        Note: new FormControl('', Validators.maxLength(1024)),
        ModifyDate: new FormControl(null),
        StatusID: new FormControl(''),
        SubStatusID: new FormControl(''),
        IsEditNotAllowed: new FormControl(false),
        IsDeleteNotAllowed: new FormControl(false),
        ViewStartTime: new FormControl(''),
        Status: new FormControl('')
      });
      return TechnicianFormRow;

    }
    else if (IsPrimaryTech) {
      // Primary Tech
      let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
      let technicianCodeTypeId = appointmentTypes.find(x => x.Code == 'PrimaryTech').ID;
      let primaryTechnicianArray = data.UserAppointments.filter(x => x.AppointmentTypeID == technicianCodeTypeId);

      if (!CommonMethods.CheckNullOrUndefined(primaryTechnicianArray) && primaryTechnicianArray.length > 0) {
        let primaryTechnician = primaryTechnicianArray[0];

        let helperDate: string = this.datePipe.transform(primaryTechnician.AppointmentDate, "MM/dd/yyyy");
        let startTimeDt: Date = new Date(helperDate + " " + primaryTechnician.StartTime);
        let endTimeDt: Date = new Date(helperDate + " " + primaryTechnician.EndTime);
        let DurationHour: number = 0;
        let DurationMin: string = '00';
        let Duration: number = 0;

        if (!isNaN(startTimeDt.getTime()) && !isNaN(endTimeDt.getTime())) {
          let hours = Math.floor((endTimeDt.getTime() - startTimeDt.getTime()) / 3600000);
          let min = (Math.floor((endTimeDt.getTime() - startTimeDt.getTime()) % 3600000) / 60000);
          DurationHour = hours;
          DurationMin = (min == 0 ? '00' : min.toString());
          Duration = (DurationHour) * 60 + parseInt(DurationMin);
        }
        
        let TechnicianFormRow = new FormGroup({
          ID: new FormControl(primaryTechnician.ID),
          HelperId: new FormControl(primaryTechnician.UserID, Validators.required),
          Name: new FormControl(!CommonMethods.CheckNullOrUndefined(primaryTechnician.User)?primaryTechnician.User.FirstName + "" + primaryTechnician.User.LastName: ""),
          Date: new FormControl(startTimeDt, [Validators.required, this.CustomDateValidator]),
          StartTime: new FormControl(startTimeDt, [Validators.required, this.CustomDateValidator, this.EventOneDayTimeValidator]),
          DurationHour: new FormControl(DurationHour, [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
          DurationMin: new FormControl(DurationMin, [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
          autoschedule: new FormControl(primaryTechnician.IsSchedule),
          Duration: new FormControl(Duration, Validators.required),
          Note: new FormControl(primaryTechnician.Note),
          Dirty: new FormControl(true),
          ModifyDate: new FormControl(primaryTechnician.ModifyDate),
          StatusID: new FormControl(primaryTechnician.StatusID),
          SubStatusID: new FormControl(primaryTechnician.SubStatusID),
          PromisedTime: new FormControl(data.PromisedTime != null && isPromiseTimeExistsInList ? data.PromisedTime.ID : "", Validators.required),
          IsEditNotAllowed: new FormControl(false),
          IsDeleteNotAllowed: new FormControl(false),
          ViewStartTime: new FormControl(''),
          Status: new FormControl('')
        });
        return TechnicianFormRow;
      }
      else {
        let TechnicianEmptyFormRow = new FormGroup({
          ID: new FormControl(''),
          HelperId: new FormControl('', Validators.required),
          Name: new FormControl(''),
          Date: new FormControl('', [Validators.required,this.CustomDateValidator]),
          StartTime: new FormControl('', [Validators.required, this.CustomDateValidator, this.EventOneDayTimeValidator]),
          DurationHour: new FormControl('1', [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
          DurationMin: new FormControl('00', [Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]),
          autoschedule: new FormControl(false),
          Duration: new FormControl('', Validators.required),
          Note: new FormControl(''),
          Dirty: new FormControl(true),
          ModifyDate: new FormControl(''),
          StatusID: new FormControl(''),
          SubStatusID: new FormControl(''),
          PromisedTime: new FormControl(data.PromisedTime != null && isPromiseTimeExistsInList ? data.PromisedTime.ID : "", Validators.required),
          IsEditNotAllowed: new FormControl(false),
          IsDeleteNotAllowed: new FormControl(false),
          ViewStartTime: new FormControl(''),
          Status: new FormControl(''),
        });
        return TechnicianEmptyFormRow;
      }
    }
    else {
      // helpers 
      this.HelpersForm.reset();
      this.HelpersForm = this.frmbuilder.array([]);

      let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
      let technicianCodeTypeId = appointmentTypes.find(x => x.Code == 'Helper').ID;
      let helpersArray: any = data.UserAppointments.filter(x => x.AppointmentTypeID == technicianCodeTypeId);
      if (!CommonMethods.CheckNullOrUndefined(helpersArray) && helpersArray.length > 0) {
        helpersArray.forEach((helperObject) => {
          let helperDate: string = this.datePipe.transform(helperObject.AppointmentDate, "MM/dd/yyyy");
          let startTimeDt: Date = new Date(helperDate + " " + helperObject.StartTime);
          let endTimeDt: Date = new Date(helperDate + " " + helperObject.EndTime);
          let DurationHour: number = 0;
          let DurationMin: string = '00';
          let Duration: number = 0;

          if (!isNaN(startTimeDt.getTime()) && !isNaN(endTimeDt.getTime())) {
            let hours = Math.floor((endTimeDt.getTime() - startTimeDt.getTime()) / 3600000);
            let min = (Math.floor((endTimeDt.getTime() - startTimeDt.getTime()) % 3600000) / 60000);
            DurationHour = hours;
            DurationMin = (min == 0 ? '00' : min.toString());
            Duration = (DurationHour) * 60 + parseInt(DurationMin);
          }

          let HelperFormRow = new FormGroup({
            ID: new FormControl(helperObject.ID),
            HelperId: new FormControl(helperObject.UserID, Validators.required),
            Name: new FormControl(!CommonMethods.CheckNullOrUndefined(helperObject.User)?helperObject.User.FirstName + "" + helperObject.User.LastName: ""),
            Date: new FormControl(new Date(helperDate), [Validators.required, this.CustomDateValidator]),
            StartTime: new FormControl(startTimeDt, [Validators.required, this.CustomDateValidator, this.EventOneDayTimeValidatorForHelper]),
            DurationHour: new FormControl(DurationHour, [Validators.required, this.EventOneDayTimeValidatorForHelper, this.DurationValidator]),
            DurationMin: new FormControl(DurationMin, [Validators.required, this.EventOneDayTimeValidatorForHelper, this.DurationValidator]),
            autoschedule: new FormControl(helperObject.IsSchedule),
            Duration: new FormControl(Duration),
            Note: new FormControl(helperObject.Note),
            Dirty: new FormControl(true),
            ModifyDate: new FormControl(helperObject.ModifyDate),
            StatusID: new FormControl(helperObject.StatusID),
            SubStatusID: new FormControl(helperObject.SubStatusID),
            IsEditNotAllowed: new FormControl(this.commonMethods.IsHelperEditOrDeleteNotAllowed(helperObject, 0)),
            IsDeleteNotAllowed: new FormControl(this.commonMethods.IsHelperEditOrDeleteNotAllowed(helperObject, 1)),
            ViewStartTime: new FormControl(this.datePipe.transform(new Date(helperDate + " " + helperObject.StartTime), "hh:mm a")),
            Status: new FormControl(this.commonMethods.GetHelperStatus(helperObject.StatusID, helperObject.SubStatusID).Name)
          });
          this.HelpersForm.push(HelperFormRow);
        });

        let HelperFormEmptyRow = new FormGroup({
          ID: new FormControl(CommonMethods.GetID()),
          HelperId: new FormControl('', this.ValidateHelperId),
          Name: new FormControl(''),
          Date: new FormControl('', [this.ValidateHelperId, this.CustomDateValidator]),
          StartTime: new FormControl('', [this.ValidateHelperId, this.CustomDateValidator, this.EventOneDayTimeValidatorForHelper]),
          DurationHour: new FormControl('1', [this.ValidateHelperId, this.EventOneDayTimeValidatorForHelper, this.DurationValidator]),
          DurationMin: new FormControl('00', [this.ValidateHelperId, this.EventOneDayTimeValidatorForHelper, this.DurationValidator]),
          autoschedule: new FormControl(false),
          Duration: new FormControl(''),
          Note: new FormControl(''),
          Dirty: new FormControl(false),
          ModifyDate: new FormControl(''),
          StatusID: new FormControl(''),
          SubStatusID: new FormControl(''),
          PromisedTime: new FormControl(''),
          IsEditNotAllowed: new FormControl(false),
          IsDeleteNotAllowed: new FormControl(false),
          ViewStartTime: new FormControl(''),
          Status: new FormControl('')
        });
        this.HelpersForm.push(HelperFormEmptyRow);
        return null;
      }
      else {
        let HelperFormEmptyRow = new FormGroup({
          ID: new FormControl(CommonMethods.GetID()),
          HelperId: new FormControl('', this.ValidateHelperId),
          Name: new FormControl(''),
          Date: new FormControl('', this.ValidateHelperId),
          StartTime: new FormControl('', this.ValidateHelperId),
          DurationHour: new FormControl('1', this.ValidateHelperId),
          DurationMin: new FormControl('00', this.ValidateHelperId),
          autoschedule: new FormControl(false),
          Duration: new FormControl(''),
          Note: new FormControl(''),
          Dirty: new FormControl(false),
          ModifyDate: new FormControl(''),
          StatusID: new FormControl(''),
          SubStatusID: new FormControl(''),
          PromisedTime: new FormControl(''),
          IsEditNotAllowed: new FormControl(false),
          IsDeleteNotAllowed: new FormControl(false),
          ViewStartTime: new FormControl(''),
          Status: new FormControl('')
        });
        this.HelpersForm.push(HelperFormEmptyRow);
        return null;
      }
    }
  }

  private IntializeForm(data) {
    let isServiceTypeExistsInList = false;
    let isPromiseTimeExistsInList = false;
    let isPriorityExistsInList = false;

    if (!CommonMethods.CheckNullOrUndefined(this.initialData)) {
      let promisedTimes = this.GetPromiseTimes();
      isServiceTypeExistsInList = this.CheckElementExistsInList(data.ServiceType.ID, this.initialData.ServiceTypes);
      isPromiseTimeExistsInList = this.CheckElementExistsInList(data.PromisedTime.ID, promisedTimes);
      isPriorityExistsInList = this.CheckElementExistsInList(data.Priority.ID, this.initialData.WorkTicketPriorityLookup);
    }

    //create Helpers Form
    this.CreateForm(data, false);

    this.editWorkTicketForm = this.frmbuilder.group({
      ID: new FormControl(data.ID),
      DispatchComment: new FormControl(data.DispatchComment, [Validators.required, this.commonMethods.noWhitespaceValidator, Validators.maxLength(1024)]),
      JobSite: new FormControl(data.JobSite),
      Customer: new FormControl(data.Customer),
      ServiceType: new FormControl(data.ServiceType != null && isServiceTypeExistsInList ? data.ServiceType.ID : "", Validators.required),
      Department: new FormControl(data.Department != null ? data.Department.ID : "", Validators.required),

      OwnerUser: new FormControl(data.OwnerUser != null ? data.OwnerUser.ID : ""),
      Priority: new FormControl(data.Priority != null && isPriorityExistsInList ? data.Priority.ID : "", Validators.required),
      RequestedBy: new FormControl(data.RequestedBy),

      CustomerPO: new FormControl("Dummy Text"),
      Issue: new FormControl(data.Issue),
      InvoiceComment: new FormControl(data.WorkTicketPayment != null ? data.WorkTicketPayment.InvoiceComment : ""),
      WorkTicketPriceBookItems: new FormControl([]),
      WorkTicketDiscountItems: new FormControl([]),
      WorkTicketPayment: new FormControl(null),
      SelectedTaxGroupID: new FormControl(""),
      /** 1: Now, 2: Later */
      ScheduleType: new FormControl("2"),

      AssignedHelpers: this.HelpersForm,
      PrimaryTechnician: this.CreateForm(data, true, '1', isPromiseTimeExistsInList)


    });
    if (this.editWorkTicketForm.get("PrimaryTechnician.HelperId").value != '') {
      this.editWorkTicketForm.get("ScheduleType").patchValue("1");
    }
    else {
      this.editWorkTicketForm.get('PrimaryTechnician').setValue(this.CreateForm(data, true, this.editWorkTicketForm.get("ScheduleType").value, isPromiseTimeExistsInList).value);

    }

    let self = this;
    let subscription = this.editWorkTicketForm.controls["ScheduleType"].valueChanges.subscribe(value => {
      if (value == 1) {
        if (self.editWorkTicketForm.get("PrimaryTechnician.HelperId").value == CommonMethods.GetID())
          self.editWorkTicketForm.get("PrimaryTechnician.HelperId").patchValue('');

        self.editWorkTicketForm.get("PrimaryTechnician.StartTime").setValidators([Validators.required,this.EventOneDayTimeValidator]);
        self.editWorkTicketForm.get("PrimaryTechnician.HelperId").setValidators([Validators.required]);
        self.editWorkTicketForm.get("PrimaryTechnician.DurationHour").setValidators([Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]);
        self.editWorkTicketForm.get("PrimaryTechnician.DurationMin").setValidators([Validators.required, this.EventOneDayTimeValidator, this.DurationValidator]);
      } else {
        self.editWorkTicketForm.get("PrimaryTechnician.StartTime").setValidators(null);
        self.editWorkTicketForm.get("PrimaryTechnician.HelperId").setValidators(null);
        self.editWorkTicketForm.get("PrimaryTechnician.DurationHour").setValidators([Validators.required, this.DurationValidator]);
        self.editWorkTicketForm.get("PrimaryTechnician.DurationMin").setValidators([Validators.required, this.DurationValidator]);
      }
      self.editWorkTicketForm.get("PrimaryTechnician.StartTime").updateValueAndValidity();
      self.editWorkTicketForm.get("PrimaryTechnician.HelperId").updateValueAndValidity();
      self.editWorkTicketForm.get("PrimaryTechnician.DurationHour").updateValueAndValidity();
      self.editWorkTicketForm.get("PrimaryTechnician.DurationMin").updateValueAndValidity();
    });
    this.editWorkTicketForm.updateValueAndValidity();
    this.editWorkTicketForm.get('PrimaryTechnician').updateValueAndValidity();
    this.editWorkTicketForm.get('AssignedHelpers').updateValueAndValidity();

    this.subscriptions.push(subscription);

    if (this.Details != undefined) {
      this.customerAddress = CommonMethods.GetCompleteAddress(this.Details.Customer);
      this.jobSiteAddress = CommonMethods.GetCompleteAddress(this.Details.JobSite)
      if(this.Details.EstimatesOriginatedFrom != null)
        this.estimateItems = { data: this.Details.EstimatesOriginatedFrom, total: this.Details.EstimatesOriginatedFrom.length }
      else this.estimateItems = { data: [], total: 0 };
      if(this.estimateItems.total > 0)
        this.subTabs.push(new TemplateModel(3, 'Estimates', this.tab4Ref, false));

      this.Details.WorkTicketPriceBookItems.forEach(x => {
        let newElement = x.PriceBookItem;
        newElement.Price = (x.AgreementPrice != null && x.Price == x.OriginalPrice)? x.AgreementPrice : x.Price;
        newElement.Quantity = x.Quantity;
        newElement.LineCounter = x.LineCounter;
        newElement.parentID = x.ID;
        newElement.Description = x.Description;
        newElement.Status = x.Status;
        newElement.WorkStatus = x.WorkStatus;
        newElement.WorkTicketPriceBookLinkingId = x.ID;
        newElement.AccountingCode = x.PriceBookAccountingCode;
        newElement.IsTaxable = x.IsTaxable;
        newElement.Note = x.Note;
        newElement.ImagePath = this.commonMethods.GetProductDefaultImg(newElement);
        newElement.WorkTicketPriceBookItemEquipments = x.WorkTicketPriceBookItemEquipments;
        if (x.ServiceAgreement != null) {
          newElement.ServiceAgreementID = x.ServiceAgreement.ID;
          newElement.ServiceAgreementNo = x.ServiceAgreement.AgreementID;
        }
        if (x.Estimate != null) {
          newElement.Estimate =  x.Estimate
          newElement.Estimate.CustomerID =this.Details.Customer.ID;
        }
        newElement.AgreementPrice = x.AgreementPrice;
        newElement.OriginalPrice = x.OriginalPrice;
        newElement.IsUsedToOverridePrice = x.IsUsedToOverridePrice;
        newElement.ServiceAgreementCreated = x.ServiceAgreementCreated;
        this.selectedItems.push(newElement);
        this.GetAPBItems();
        if (x.IsUsedToOverridePrice == true) {
          this.overrideItemIds.push(x.PriceBookItem.ID);
        }
      });
      this.workTicketItems = this.Details.WorkTicketItems;
      //this needs to be changed after line item changes in API
      if (this.Details.WorkTicketDiscountItems.length > 0) {
        this.selectedDiscount = this.ToWorkTicketDiscountModel(
          this.Details.WorkTicketDiscountItems[0]
        );
        this.selectedDiscount.IsDirty = false;
      } else {
        this.selectedDiscount = new WorkTicketDiscountItem();
        this.selectedDiscount.IsDeleted = true;
      }
      if (
        this.Details.WorkTicketPayment != null &&
        this.Details.WorkTicketPayment.TaxGroup != null
      ) {
        this.wtSelectedTaxGroup = this.Details.WorkTicketPayment.TaxGroup;
      }
    }
  }

  CheckElementExistsInList(value: any, array: any[]) {
    let isExists = false;
    if (!CommonMethods.CheckNullOrUndefined(array)) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.ID == value) {
          isExists = true;
          break;
        }
      }
    }
    return isExists;
  }

  private InitAssignedTechnician(data) {
    if (data != null) {
      if (data.IsPrimary) {
        this.isFirstTechSelected = true;
      }
      return new FormGroup({
        ID: new FormControl(data.ID != null && data.ID != undefined ? data.ID : ""),
        User: new FormControl(data.User != null
          ? this.technicians.find(x => x.ID == data.User.ID) == undefined
            ? ""
            : data.User.ID
          : ""
        ),
        StartTime: new FormControl(data.StartTime, [this.TimeValidation]),
        EndTime: new FormControl(data.EndTime, [this.TimeValidation]),
        PromisedDate: new FormControl(new Date(data.PromisedDate)),
        IsPrimary: new FormControl(data.IsPrimary)
      });
    } else {
      return new FormGroup({
        User: new FormControl(""),
        StartTime: new FormControl("", [this.TimeValidation]),
        EndTime: new FormControl("", [this.TimeValidation]),
        PromisedDate: new FormControl(null),
        Category: new FormControl(""),
        IsPrimary: new FormControl(false)
      });
    }
  }
  private IncrementTime() {
    var x = 15; //minutes interval
    var starttime = 0;
    var ampm = ["AM", "PM"];

    for (var i = 0; starttime < 24 * 60; i++) {
      var hrs = Math.floor(starttime / 60);
      var mins = starttime % 60;
      this.times[i] = ("0" + (hrs % 12)).slice(-2) + ":" + ("0" + mins).slice(-2) + " " + ampm[Math.floor(hrs / 12)];
      starttime = starttime + x;
    }
  }
  private ConvertTimespan(value) {
    if (value == null) {
      return "";
    }
    let values = value.split(":");
    let hour = "";
    let minute = values[1];
    let ampm = "";
    if (parseInt(values[0]) > 12) {
      ampm = "PM";
      hour = this.Pad(parseInt(values[0]) - 12, 2);
    } else if (values[0] == "12") {
      hour = this.Pad(parseInt(values[0]), 2);
      ampm = "PM";
    } else {
      hour = this.Pad(parseInt(values[0]), 2);
      ampm = "AM";
    }
    return hour + ":" + minute + " " + ampm;
  }
  private Pad(num, size) {
    return Constants.Pad(num, size);
  }
  private AddRow(data) {
    const formArr = <FormArray>(
      this.editWorkTicketForm.controls["AssignedTechnicians"]
    );
    formArr.push(this.InitAssignedTechnician(data));
  }
  private ApplyDiscountAndTaxRate() {
    this.SetTotalTaxRate();
    let totalPrice = 0;
    let netTaxable = 0;
    let totalDiscount = 0;
    let totalTaxedAmount = 0;
    let positiveApprovedItems = this.selectedItems.filter(x => x.Price * x.Quantity > 0);
    let positiveApprovedItemsTotAmt = positiveApprovedItems.reduce((a, b) => a + b.Quantity * b.Price, 0);
    let allApprovedItemsTotAmt = this.selectedItems.reduce((a, b) => a + b.Quantity * b.Price, 0);

    // Calculate each item's discount and tax
    this.selectedItems.forEach(element => {
      let totalItemPrice = element.Price * element.Quantity;
      let discount = 0;
      totalPrice = totalPrice + totalItemPrice;

      // Percent type discount
      if (!this.selectedDiscount.IsDeleted && this.selectedDiscount.DiscountType.Code == "percent") {
        discount = totalItemPrice > 0
          ? Math.round((totalItemPrice / positiveApprovedItemsTotAmt)
            * (this.selectedDiscount.Discount.Amount / 100)
            * allApprovedItemsTotAmt * 100) / 100
          : 0;
      }
      // Dollar type discount
      else if (!this.selectedDiscount.IsDeleted && this.selectedDiscount.DiscountType.Code == "dollar") {
        discount = totalItemPrice > 0
          ? (totalItemPrice / positiveApprovedItemsTotAmt) * this.selectedDiscount.Discount.Amount
          : 0;
      }

      // Calculate tax on the items after discount is applied
      if (element.IsTaxable) {
        let itemNetTaxable = totalItemPrice - discount;
        netTaxable += itemNetTaxable;
        totalTaxedAmount += ((itemNetTaxable * this.totalTaxRate) / 100);
      }
    });
    if (!this.selectedDiscount.IsDeleted) {
      totalDiscount =
        this.selectedDiscount.DiscountType.Code == "dollar"
          ? this.selectedDiscount.Discount.Amount
          : totalPrice * (this.selectedDiscount.Discount.Amount / 100);
    }

    // this.TotalItemPrice = totalPrice;

    this.workTicketPayment.TotalApproved = totalPrice.roundTo(2);

    //this.netTaxable 
    this.workTicketPayment.NetTaxable = netTaxable;

    // this.taxedAmount = totalTaxedAmount;
    this.workTicketPayment.TaxedAmount = totalTaxedAmount;

    // this.discountAmount = totalDiscount;
    this.workTicketPayment.DiscountAmount = totalDiscount;

    // this.totalAmount = totalPrice + totalTaxedAmount - totalDiscount;
    this.workTicketPayment.TotalAmount = this.workTicketPayment.TotalApproved +
      this.workTicketPayment.TaxedAmount - this.workTicketPayment.DiscountAmount;

    this.workTicketPayment.TotalAmount = this.workTicketPayment.TotalAmount.roundTo(2);//rounding

    let TotalPaid = 0;
    if (this.Details.WorkTicketPayment == null || this.Details.WorkTicketPayment.TotalPaid == null) {
      TotalPaid = 0;
    } else {
      TotalPaid = this.Details.WorkTicketPayment.TotalPaid;
    }
    this.workTicketPayment.TotalPaid = TotalPaid
    //this.balanceOwed= this.totalAmount - TotalPaid; //// - AppliedCredit;
    this.workTicketPayment.BalanceOwed = this.workTicketPayment.TotalAmount - this.workTicketPayment.TotalPaid; // - AppliedCredit;
    this.workTicketPayment.BalanceOwed = this.workTicketPayment.BalanceOwed.roundTo(2);//rounding
  }

  private SetTotalTaxRate() {
    this.totalTaxRate = 0;
    if (this.wtSelectedTaxGroup != null && this.wtSelectedTaxGroup != undefined) {
      let rate = 0;
      if (this.Details.Status.Code.toLowerCase() == Constants.WOStaticStatus().completed) {
        rate = this.Details.WorkTicketPayment != null ? this.Details.WorkTicketPayment.TaxRate : 0;
      } else {
        this.wtSelectedTaxGroup.TaxCodes.forEach(element => {
          rate = rate + element.Rate;
        });
      }
      this.totalTaxRate = rate;
    }
  }

  private GenerateRandomID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  private GetAPBItems() {
    let list = this.selectedItems.filter(
      x => x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved
    );
    this.approvedPBItems = { data: list, total: list.length };
    this.setAgreementDiscount();
  }

  private CalculateEffectiveAmount(itemPrice: number, itemQuantity: number, IsTaxable: boolean, IsDiscountExcluded: boolean) {
    this.SetTotalTaxRate();
    // let TotalItemPrice = this.TotalItemPrice - itemPrice * itemQuantity;
    let TotalItemPrice = this.workTicketPayment.TotalApproved - itemPrice * itemQuantity;
    let TotalAmount = this.workTicketPayment.TotalAmount;//this.totalAmount;
    let NetTaxable = this.workTicketPayment.NetTaxable;//this.netTaxable;    
    let taxedAmount = this.workTicketPayment.TaxedAmount;//this.taxedAmount;
    let discountableAmount = 0;
    let discountAmount = this.workTicketPayment.DiscountAmount;//this.discountAmount;
    let balanceOwed: number;
    if (IsTaxable) NetTaxable = NetTaxable - itemPrice * itemQuantity;

    this.selectedItems.forEach(element => {
      if (!element.IsDiscountExcluded)
        discountableAmount += element.Price * element.Quantity;
    });

    if (!IsDiscountExcluded)
      discountableAmount = discountableAmount - itemPrice * itemQuantity;

    if (!this.selectedDiscount.IsDeleted && this.selectedDiscount.DiscountType.Code == "percent")
      discountAmount = (discountableAmount * this.selectedDiscount.Discount.Amount) / 100;

    if (this.wtSelectedTaxGroup != undefined && this.wtSelectedTaxGroup != null) {
      let taxableAmount = NetTaxable - discountAmount;
      taxedAmount = taxableAmount > 0 ? (taxableAmount * this.totalTaxRate) / 100 : 0;
    }
    TotalAmount = TotalItemPrice + taxedAmount - discountAmount;
    let TotalPaid = 0;
    //let AppliedCredit = 0;
    if (this.Details.WorkTicketPayment == null || this.Details.WorkTicketPayment.TotalPaid == null) {
      TotalPaid = 0;
    } else {
      TotalPaid = this.Details.WorkTicketPayment.TotalPaid;
    }
    balanceOwed = TotalAmount - TotalPaid;
    return balanceOwed.roundTo(2);
  }
  private GetTotalPaidDetails() {
    if (CommonMethods.CheckNullOrUndefined(this.Details)
      || CommonMethods.CheckNullOrUndefined(this.Details.WorkTicketPayment)
      || CommonMethods.CheckNullOrUndefined(this.Details.WorkTicketPayment.WorkTicketPaidDetails)) {
      this.totalPaidDetails = { data: [], total: 0 };
    } else {
      this.totalPaidDetails = {
        data: this.Details.WorkTicketPayment.WorkTicketPaidDetails,
        total: this.Details.WorkTicketPayment.WorkTicketPaidDetails.length
      };
    }
  }
  private GetDiscountAndTaxedAmount() {
    if (CommonMethods.CheckNullOrUndefined(this.workTicketPayment))
      this.workTicketPayment = new WorkTicketPaymentSummary();

    if (this.Details.WorkTicketPayment == null) {
      // this.totalAmount = 0;
      this.workTicketPayment.TotalAmount = 0;
      // this.taxedAmount = 0;
      this.workTicketPayment.TaxedAmount = 0;
      // this.balanceOwed = 0;
      this.workTicketPayment.BalanceOwed = 0;
      // this.TotalItemPrice = 0;
      this.workTicketPayment.TotalApproved = 0;
      // this.discountAmount = 0;
      this.workTicketPayment.DiscountAmount = 0;
      // this.netTaxable = 0;
      this.workTicketPayment.NetTaxable = 0;
      return;
    }
    if (!CommonMethods.CheckNullOrUndefined(this.Details.WorkTicketPayment)) {
      this.workTicketPayment.TotalPaid = this.Details.WorkTicketPayment.TotalPaid;
      //this.netTaxable = 
      this.workTicketPayment.NetTaxable = this.Details.WorkTicketPayment.NetTaxable;
      //this.taxedAmount =
      this.workTicketPayment.TaxedAmount = this.Details.WorkTicketPayment.TaxedAmount;
      //this.TotalItemPrice =
      this.workTicketPayment.TotalApproved = this.Details.WorkTicketPayment.TotalApprovedPrice;
      this.workTicketPayment.TotalApproved = this.workTicketPayment.TotalApproved.roundTo(2);//rounding
      //this.discountAmount = 
      this.workTicketPayment.DiscountAmount = this.Details.WorkTicketPayment.TotalDiscount;
      // this.totalAmount = this.Details.WorkTicketPayment.TotalApprovedPrice + this.Details.WorkTicketPayment.TaxedAmount -this.discountAmount;
      this.workTicketPayment.TotalAmount = this.workTicketPayment.TotalApproved + this.workTicketPayment.TaxedAmount - this.workTicketPayment.DiscountAmount;
      // this.balanceOwed = this.totalAmount - this.Details.WorkTicketPayment.TotalPaid; ////// - this.Details.WorkTicketPayment.AppliedCredit;
      this.workTicketPayment.BalanceOwed = this.workTicketPayment.TotalAmount - this.workTicketPayment.TotalPaid; ////// - this.Details.WorkTicketPayment.AppliedCredit;
    }
  }

  private SetDiscountValues(discount: any, setDirty?: boolean) {
    let discountType = discount.DiscountType.Code;
    this.selectedDiscount.Name = discount.Name;
    this.selectedDiscount.Rate = discount.Rate;
    this.selectedDiscount.Discount = Object.assign({}, discount);
    if (setDirty != undefined && setDirty != null && setDirty == true)
      this.selectedDiscount.IsDirty = setDirty;

    if (!CommonMethods.CheckNullOrUndefined(discount["IsCustom"])) {
      this.selectedDiscount.IsCustom = discount["IsCustom"];
    }
    this.selectedDiscount.IsDeleted = false;
    this.selectedDiscount.DiscountType = discount.DiscountType;
    if (discountType == "percent") {
      let discountableAmount = 0;
      this.selectedItems.forEach(element => {
        if (!element.IsDiscountExcluded) {
          discountableAmount += element.Price * element.Quantity;
        }
      });
      //this.discountAmount = (discountableAmount * discount.Amount) / 100; //Rate here will be rate %
      this.workTicketPayment.DiscountAmount = (discountableAmount * this.selectedDiscount.Rate) / 100; //Rate here will be rate %
    } else {
      //this.discountAmount = this.selectedDiscount.Rate; //Rate here will be actual amount in the dollars
      this.workTicketPayment.DiscountAmount = this.selectedDiscount.Discount.Amount; //Rate here will be actual amount in the dollars
    }
  }
  private IntializeCustomDiscountForm(formData) {
    this.popupDiscountType = formData.DiscountType.Code;
    this.customDiscountForm = this.frmbuilder.group({
      Name: new FormControl({ value: formData.Name, disabled: !formData.IsNameEditable }, Validators.required),
      Rate: new FormControl({ value: formData.Amount, disabled: !formData.IsAmountEditable })
    });
  }

  private LoadInitialData(data) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    let subscription = this.httpCommon
      .GetIntialData(
        this.auth.getCompanyId(),
        "PromisedTimes,Discounts,TaxGroups,ServiceTypes,Departments,workticketprioritylookup,users,CodeTypeData,pricebuckets"
      )
      .subscribe(response => {
        this.initialData = response;
        this.discounts =
          response.Discounts != null
            ? response.Discounts.filter(x => x.IsActive)
            : [];
        this.bucket = response.PriceBuckets.find(
          x => x.Name.toLowerCase() == "standard"
        );
        this.taxGroups =
          response.TaxGroups != null
            ? response.TaxGroups.filter(x => x.IsActive)
            : [];
        this.Details = data;
        this.IntializeForm(this.Details);
        this.GetDiscountAndTaxedAmount();
        if (!CommonMethods.CheckNullOrUndefined(this.Details.JobSite.Contacts, true)) {
          this.primaryJobSiteContact = this.Details.JobSite.Contacts.find(x => x.Contact.IsPrimary);
          if (CommonMethods.CheckNullOrUndefined(this.primaryJobSiteContact.Contact.LastName))
            this.primaryJobSiteContact.Contact.LastName = "";
        }
        if (!CommonMethods.CheckNullOrUndefined(this.Details.Customer.Contacts, true)) {
          this.primaryCustomerContact = this.Details.Customer.Contacts.find(x => x.Contact.IsPrimary);
          if (CommonMethods.CheckNullOrUndefined(this.primaryCustomerContact.Contact.LastName))
            this.primaryCustomerContact.Contact.LastName = "";
        }
        if (!CommonMethods.CheckNullOrUndefined(this.Details)) {
          this.estimatesConvertedTo = this.Details.EstimatesConvertedTo.find(
          x => x.IsUsedToCreateWorkTicket == true
        );
        }
        if (this.Details.WorkTicketAttachments != null) {
          this.GetWorkOrderDocumentsAndImages(this.Details.WorkTicketAttachments);
        }
        this.GetTotalPaidDetails();
        if (this.Details.Status.Code.toLowerCase() != Constants.WOStaticStatus().completed)
          this.isTaxEditable = true;
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      });
    this.subscriptions.push(subscription);
    subscription = this.httpCommon.GetTechnicianData(this.auth.getCompanyId(), 'Department').subscribe(
      response => {
        if (response != null) {
          this.technicians = response;
          this.setKendoTechData(this.technicians);
        }
      });
    this.subscriptions.push(subscription);
  }

  private DestroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }
  // #endregion

  // #region  Public Methods
  registerSearch() {
    this.itemSearchTerm$.pipe(
      debounceTime(Constants.debounceInterval),
      tap(() => {
        const count = +$('#agreement_icon_'+ this.tabCounter).attr('data');
        this.activeAgreement = count > 0? true: false;
      }),
      switchMap((val:string) => this.httpService
      .GetPriceBookItems(this.state, val, (this.activeAgreement)? this.Details.JobSite.ID : null, this.overrideItemIds).pipe(
        catchError(() => {
          return of({ Data: [], Count: 0 });
        })
    )),
    takeUntil(this.ngUnsubscribe$))
      .subscribe(response => {
        this.showspinner.hideLoader(this.MIDropDown, this.tabCounter);
        let priceBookItems = response.Data.filter(
          x => x.StandardPrice != null
        );
        this.itemDropDownFilteredVals = CommonMethods.CheckNullOrUndefined(priceBookItems)? [] : priceBookItems;
        this.itemDropDownFilteredVals.forEach(x => {
          x.ImagePath = this.commonMethods.GetProductDefaultImg(x);
          if (x.CategoryName != undefined) {
            let category: string = x.CategoryName;
            let splitCatName = category.split("/");
            x.CategoryName = splitCatName[0];
          }
        });
    });
  }
  public CloseTab() {
    this.tabOpen.ReplaceTab({
      CurrentTabIndex: this.tabCounter,
      newTabInfo: {
        tabId: Tabs.FsLiteWorkOrderView,
        params: {
          ID: this.Details.ID,
          jobsiteId: this.Details.JobSite.ID,
          customerId: this.Details.Customer.ID,
          activeSubTabIndex: this.subTabs.filter(x => x.Selected == true)[0].Name == "Estimates" ? 0 : this.subTabs.filter(x => x.Selected == true)[0].Index
        },
        tabTitle: this.Details.WorkTicketNo
      }
    });
  }

  public DateBlur(control: FormControl) {
    if (control.value == null) {
      return;
    }
    if (!control.dirty) {
      control.setErrors(null);
    } else if (control.value < new Date().setHours(0)) {
      control.setErrors({ InvalidDate: true });
    }
  }

  public SelectDiscount(val, isCustom) {
    if (this.workTicketPayment.IsApprovedAmountNegative) return;

    if (val.IsAmountEditable === false && val.IsNameEditable === false)
      isCustom = false;

    this.customDiscountModal = false;
    this.customDiscount = null;
    let discountType = val.DiscountType.Code;
    val.IsCustom = isCustom;
    if (isCustom) {
      this.customDiscountModal = true;
      this.IntializeCustomDiscountForm(val);
      this.customDiscount = val;
    } else {
      let setDirty = discountType != "percent" ? null : true;
      val.Rate = val.Amount;
      this.SetDiscountValues(val, setDirty);
    }
    this.ApplyDiscountAndTaxRate();
  }

  public ApplyCustomDiscount() {
    if (
      (this.customDiscount.IsNameEditable && this.customDiscountForm.valid) ||
      !this.customDiscount.IsNameEditable
    ) {
      let discount = Object.assign({}, this.customDiscount);
      discount["Name"] = this.customDiscountForm.controls["Name"].value;
      discount["Rate"] = this.customDiscountForm.controls["Rate"].value;
      discount["Amount"] = this.customDiscountForm.controls["Rate"].value;
      discount["IsCustom"] = true;
      if ((discount.DiscountType.Code == "percent" &&  discount["Rate"] <= 99) || 
          (discount.DiscountType.Code == "dollar" &&  discount["Rate"] <= 999.99)) {
        this.SetDiscountValues(discount, true);
        this.CloseCustomDiscountModal();
        this.ApplyDiscountAndTaxRate();
      }
    } else {
      this.commonMethods.markFormGroupTouched(this.customDiscountForm);
    }
  }

  public DeleteDiscount() {
    this.customDiscount = null;
    this.selectedDiscount.IsDeleted = true;
    // this.discountAmount = 0;
    this.workTicketPayment.DiscountAmount = 0;
    this.ApplyDiscountAndTaxRate();
  }

  public CloseCustomDiscountModal() {
    this.customDiscountForm.reset();
    this.customDiscountModal = false;
    this.customDiscount = null;
  }
  public QuantityChanged(val, dataItem) {
    dataItem.Quantity = val;
    this.isPriceBookWorkItemModified =true;
    dataItem.IsDirty = true;
    if (
      dataItem.WorkTicketPriceBookLinkingId != undefined &&
      dataItem.WorkTicketPriceBookLinkingId != null
    )
      this.workTicketItems
        .filter(x => x.WorkTicketPriceBookItem != null && x.WorkTicketPriceBookItem.ID == dataItem.WorkTicketPriceBookLinkingId)
        .forEach(y => {
          let mQuantity = 0;          
          
          if (val == null)
            mQuantity = y.Quantity;
          else if (val > 0) 
            mQuantity = val * y.UnitQuantity; 

          y.Quantity = mQuantity;
          y.OpenIssueQuantity = mQuantity - y.Issued;
          y.IsDirty = true;
        });
    this.editWorkTicketForm.markAsDirty();
    this.ApplyDiscountAndTaxRate();
    this.setAgreementDiscount();
  }

  public ConfirmRemoveItem(dataItem) {
    let message = "Are you sure you want to delete this line item?";
    if (dataItem.Type == this.itemType.Agreement && dataItem.IsUsedToOverridePrice) {
      message =
      "Removing Service Agreement " + dataItem.ItemNumber + " will remove overridden price. Do you wish to continue?";
    } else if (
      dataItem.Estimate != undefined && 
      dataItem.Estimate != null &&
      dataItem.Estimate.EstimateNo != null) {
      message =
      "You are about to delete an item that came from Estimate (" + dataItem.Estimate.EstimateNo + ")  Are you sure you want to proceed?";
    } else if (
      dataItem.Status != undefined &&
      dataItem.Status != null &&
      dataItem.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved
    ) {
      message =
        "Deleting this APPROVED item will affect the Work Order Total, Are you sure you want to delete?";
      let effectiveBalanceOwed = this.CalculateEffectiveAmount(
        dataItem.Price,
        dataItem.Quantity,
        dataItem.IsTaxable,
        dataItem.IsDiscountExcluded
      );
      if (effectiveBalanceOwed < 0) {
        message =
          "Deleting this APPROVED item will reduce Balance Owing to be less than $ 0, Are you sure you want to delete?";
      }
    }
    this.messageRemoveItemConfirmation = message;
    this.currentRemoveItemIndex = this.selectedItems.indexOf(dataItem);
    this.showItemDeleteConfirmation = true;
  }

  public CancelRemoveItem() {
    this.showItemDeleteConfirmation = false;
    this.currentRemoveItemIndex = null;
  }

  public RemoveItem() {
    let workTicketPriceBookLinkingId = this.selectedItems[
      this.currentRemoveItemIndex
    ].WorkTicketPriceBookLinkingId;
    if (
      (workTicketPriceBookLinkingId !=
        undefined &&
        workTicketPriceBookLinkingId != null &&
        workTicketPriceBookLinkingId != "")
    ) {
      this.workTicketItems
        .filter(
          x =>
            x.WorkTicketPriceBookItem != null &&
            x.WorkTicketPriceBookItem.ID == workTicketPriceBookLinkingId
        )
        .forEach(y => {
          let idx = this.workTicketItems.indexOf(y);
          this.workTicketItems.splice(idx, 1);
        });
    }
    const item = this.selectedItems[this.currentRemoveItemIndex];
    this.selectedItems.splice(this.currentRemoveItemIndex, 1);
    if (item && item.Type == this.itemType.Agreement && item.IsUsedToOverridePrice) {
      this.recalculateSpinner = true;
      const ovrIndex = this.overrideItemIds.findIndex(x => item.ID);
      this.overrideItemIds.splice(ovrIndex, 1);
      this.checkIsUsedToOverridePrice();
    } else {
      this.GetAPBItems();
      this.ApplyDiscountAndTaxRate();
    }
    this.showItemDeleteConfirmation = false;
    this.currentRemoveItemIndex = null;
  }

  public DescriptionChanged(event, dataItem) {
    dataItem.Description = $(event.target).val();
    this.editWorkTicketForm.markAsDirty();
    this.isPriceBookWorkItemModified =true;
  }

  public PriceChanged(val, dataItem) {
    dataItem.Price = val;
    this.editWorkTicketForm.markAsDirty();
    this.isPriceBookWorkItemModified =true;
    this.ApplyDiscountAndTaxRate();
    this.setAgreementDiscount();
  }

  public WorkStatusChange(val, dataItem) {
    dataItem.WorkStatus = val;
    this.editWorkTicketForm.markAsDirty();
  }

  public ItemNoteChanged(event, dataItem) {
    dataItem.Note = $(event.target).val();
    this.editWorkTicketForm.markAsDirty();
    let item = this.selectedItems.filter(x => x.ID == dataItem.ID);
    item.Note = $(event.target).val();
    this.GetAPBItems();
  }

  public SelectionChange(value: any, ref: any): void {
    value.Quantity = 1;
    value.OriginalPrice = value.StandardPrice;
    value.Price = value.AgreementPrice != null ? value.AgreementPrice : value.StandardPrice;
    value.ServiceAgreementID = value.AgreementID;
    value.ServiceAgreementNo = value.AgreementNo;
    this.editWorkTicketForm.markAsDirty();
    value.rowID = Math.random();
    value.WorkTicketPriceBookLinkingId = this.GenerateRandomID();
    value.WorkTicketPriceBookItemEquipments = [];
    value.Status = this.initialData.CodeTypeData.WorkTicketItemStatus.find(
      x => x.Code.toLowerCase() == "approved"
    );
    value.ImagePath = this.commonMethods.GetProductDefaultImg(value);
    if (!CommonMethods.CheckNullOrUndefined(value.AccountingCodeID))
      value.AccountingCode = { ID: value.AccountingCodeID };
    this.selectedItems.push(value);
    if (value.Type == this.itemType.Material) {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
      let subscription = this.httpMaterialItem.GetMaterialItem(value.EntityID).subscribe(response => {
        if (response != null) {
          response.Quantity = 1;
          response.UnitQuantity = 1;
          response.rowID = Math.random();
          response.Status = value.Status;
          response.OpenIssueQuantity = 1;
          response.Issued = 0;
          response.WorkTicketPriceBookLinkingId =
            value.WorkTicketPriceBookLinkingId;
          response.Item = response.MaterialDetails;
          response.WorkTicketPriceBookItem = {
            ID: value.WorkTicketPriceBookLinkingId
          };
          this.workTicketItems.push(response);
        }
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      },
        () => {
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        }
      );
      this.subscriptions.push(subscription);
    } else if (value.Type == this.itemType.Service) {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
      let subscription = this.httpServiceItem.GetServiceItem(value.EntityID).subscribe(response => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        response.MaterialItems.forEach(element => {
          if (element.MaterialItem != null) {
            element.MaterialItem.Quantity = element.Quantity;
            element.MaterialItem.UnitQuantity = element.Quantity;
            element.MaterialItem.rowID = Math.random();
            element.MaterialItem.Status = value.Status;
            element.MaterialItem.OpenIssueQuantity = element.Quantity;
            element.MaterialItem.Issued = 0;
            element.MaterialItem.WorkTicketPriceBookLinkingId =
              value.WorkTicketPriceBookLinkingId;
            element.MaterialItem.Item =
              element.MaterialItem.MaterialDetails;
            element.MaterialItem.WorkTicketPriceBookItem = {
              ID: value.WorkTicketPriceBookLinkingId
            };
            this.workTicketItems.push(element.MaterialItem);
          }
        });
      },
        () => {
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        }
      );
      this.subscriptions.push(subscription);
    } else if(value.Type == this.itemType.Agreement) {
      value.WorkStatus = this.initialData.CodeTypeData.WorkTicketItemWorkStatus.find(
        x => x.Code.toLowerCase() == "completed"
      );
    }
    this.GetAPBItems();
    this.ApplyDiscountAndTaxRate();
    setTimeout(() => {
      ref.reset();
    }, 200);
  }

  public OpenTaxEditor() {
    this.taxEditorPopup = true;
    this.selectedTaxGroup = this.wtSelectedTaxGroup;
    this.editWorkTicketForm.controls["SelectedTaxGroupID"].patchValue(
      !CommonMethods.CheckNullOrUndefined(this.selectedTaxGroup)
        ? this.selectedTaxGroup.ID
        : ""
    );
    this.SetTotalTaxRate();
  }

  public CloseTaxEditor() {
    this.taxEditorPopup = false;
    this.selectedTaxGroup = null;
    this.editWorkTicketForm.controls["SelectedTaxGroupID"].patchValue("");
  }

  public GetPromiseTimes() {
    return this.initialData != null
      ? this.initialData.PromisedTimes.filter(x => x.IsActive)
      : [];
  }

  public TimeChanged(index) {
    (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
      .at(index)
      .get("StartTime")
      .updateValueAndValidity();
    (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
      .at(index)
      .get("EndTime")
      .updateValueAndValidity();
    if (
      ((<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
        .at(index)
        .get("EndTime").value == "" ||
        (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
          .at(index)
          .get("EndTime").value == null) &&
      (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
        .at(index)
        .get("EndTime").pristine &&
      (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
        .at(index)
        .get("StartTime").value != null &&
      (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
        .at(index)
        .get("StartTime").value != ""
    ) {
      let startValue = (<FormArray>(
        this.editWorkTicketForm.controls["AssignedTechnicians"]
      ))
        .at(index)
        .get("StartTime").value;
      let endValue = new Date(startValue.getTime() + 15 * 60000);
      // if (startValue.toString().split(":")[0] == "11") {
      //   endValue = endValue.toString().replace("11", "00");
      //   if (startValue.toString().split(" ")[1] == "AM") {
      //     endValue = endValue.toString().replace("AM", "PM");
      //   } else {
      //     endValue = endValue.toString().replace("PM", "AM");
      //   }
      // } else {
      //   endValue = endValue.toString().replace(
      //     endValue.toString().split(":")[0],
      //     this.Pad(parseInt(endValue.toString().split(":")[0]) + 1, 2)
      //   );
      // }
      (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
        .at(index)
        .get("EndTime")
        .setValue(endValue);
    }
  }
  public GetDayOfWeek(date) {
    return Constants.GetDayOfWeek(date);
  }
  public SubmitForm() {
    this.updateformValidation('PrimaryTechnician');
    if (!this.editWorkTicketForm.get('PrimaryTechnician.Date').dirty) {
      this.editWorkTicketForm.get('PrimaryTechnician.Date').setErrors(null);
    }
    if (!this.editWorkTicketForm.valid || $(this._elementRef.nativeElement).find(".ng-invalid").length > 0) {
      this.destroyTab = false;
      this.commonMethods.markFormGroupTouched(this.editWorkTicketForm);
      this.commonMethods.setFocus(this.editWorkTicket.nativeElement);
      return;
    }
    // if (this.isNegativeTotalItemPrice && Math.abs(this.discountAmount) > 0) {
    if (this.workTicketPayment.TotalAmount < 0 && Math.abs(this.workTicketPayment.DiscountAmount) > 0) {
      this.toastr.error("Please remove discount and save as Subtotal is negative.", "Error");
      return;
    }
    if (this.workTicketPayment.TotalAmount < 0 || this.workTicketPayment.BalanceOwed < 0) {
      this.toastr.error("Work Order cannot be negative.", "Error");
      return;
    }
    if (!this.ValidateScheduledTime()) {
      return;
    }
    if(this.isPriceBookWorkItemModified)
    {
        this.selectedItems.forEach(x => {
          if(!this.showModifyConfirmation && x.Estimate !=null)
          {
            this.showModifyConfirmation =true;
            this.modifyMessage ="You have modified 1 or more items from estimate ("+  x.Estimate.EstimateNo + ").  Are you sure you want to proceed?";
          }
        });
        if(this.showModifyConfirmation){
          return;
        }
     }
    let submitModel: WorkOrderModel = new WorkOrderModel();
    submitModel.Attachments = this.attachments.data;
    submitModel.JobSite = new JobSiteModel();
    submitModel.JobSite.ID = this.Details.JobSite.ID;
    submitModel.Customer = new BillingDetailModel();
    submitModel.Customer.ID = this.Details.Customer.ID;
    submitModel.ServiceType = new ServiceType();
    submitModel.ServiceType.ID = this.editWorkTicketForm.controls[
      "ServiceType"
    ].value;
    submitModel.Department = new Department();
    submitModel.Department.ID = this.editWorkTicketForm.controls[
      "Department"
    ].value;
    submitModel.Status = this.Details.Status;
    submitModel.WorkTicketItems = this.workTicketItems;
    submitModel.SubStatus = this.Details.SubStatus;
    submitModel.PromisedTime = new PromisedTimeModel();
    submitModel.PromisedTime.ID = this.editWorkTicketForm.get('PrimaryTechnician.PromisedTime').value;
    let OwnerUserId = this.editWorkTicketForm.controls["OwnerUser"].value;
    submitModel.OwnerUser =
      OwnerUserId == null || OwnerUserId == ""
        ? null
        : Object.assign({ ID: OwnerUserId });
    submitModel.Priority = new WorkTicketPriority();
    submitModel.Priority.ID = this.editWorkTicketForm.controls[
      "Priority"
    ].value;
    submitModel.DispatchComment = this.editWorkTicketForm.controls[
      "DispatchComment"
    ].value;
    submitModel.RequestedBy = this.editWorkTicketForm.controls[
      "RequestedBy"
    ].value;
    submitModel.Issue = this.editWorkTicketForm.controls["Issue"].value;
    submitModel.CustomerPO = "dummy text";
    submitModel.ModifyDate = this.Details.ModifyDate;
    let editTicketForm = Object.assign({}, this.editWorkTicketForm.value);


    // technician and helper
    //primary tech
    let PrimaryTech = this.editWorkTicketForm.controls['PrimaryTechnician'].value;
    submitModel.PromisedDate = this.datePipe.transform(PrimaryTech.Date, "MM/dd/yyyy"); 
    let appointments = [];
    if (editTicketForm.ScheduleType == "1") {
      let techObj = new UserAppointment();
      techObj.ID = PrimaryTech.ID;
      techObj.UserID = PrimaryTech.HelperId;
      techObj.AppointmentDate = this.datePipe.transform(PrimaryTech.Date, "MM/dd/yyyy"); 
      let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
      let TechnicianCodeTypeID: string = appointmentTypes.find(x => x.Code == 'PrimaryTech').ID;
      techObj.AppointmentTypeID = TechnicianCodeTypeID;

      let objStartTime = PrimaryTech.StartTime;
      techObj.StartTime = new Date(
        PrimaryTech.Date.toDateString("MM/dd/yyyy") +
        " " +
        objStartTime.getHours() + ":" + objStartTime.getMinutes() + ":" + objStartTime.getSeconds()
      )
        .toTimeString()
        .split(" ")[0];

      let objEndTime = new Date(objStartTime);
      let duration = parseInt(PrimaryTech.DurationHour) * 60 + parseInt(PrimaryTech.DurationMin);
      objEndTime.setMinutes(objStartTime.getMinutes() + duration);
      techObj.EndTime = new Date(
        PrimaryTech.Date.toDateString("MM/dd/yyyy") +
        " " +
        objEndTime.getHours() + ":" + objEndTime.getMinutes() + ":" + objEndTime.getSeconds()
      )
        .toTimeString()
        .split(" ")[0];
      techObj.IsDirty = this.editWorkTicketForm.controls['PrimaryTechnician'].dirty;
      techObj.ModifyDate = PrimaryTech.ModifyDate;
      appointments.push(techObj);
    } else {
      let objStartTime = new Date();
      objStartTime.setMinutes(0);
      objStartTime.setHours(0);
      objStartTime.setSeconds(0);
      let objEndTime = new Date(objStartTime);
      let duration = parseInt(PrimaryTech.DurationHour) * 60 + parseInt(PrimaryTech.DurationMin);
      objEndTime.setMinutes(objStartTime.getMinutes() + duration);
      submitModel.Duration = new Date(
        PrimaryTech.Date.toDateString("MM/dd/yyyy") +
        " " +
        objEndTime.getHours() + ":" + objEndTime.getMinutes() + ":" + objEndTime.getSeconds()
      )
        .toTimeString()
        .split(" ")[0];
      submitModel.AssignedTechnicians = [];
    }
    
    //helpers
    let showHelperToast = false;
    this.HelpersForm.controls.forEach((helper: FormGroup) => {
      if (helper.get('HelperId').value != '') {
        let helperObj = new UserAppointment();
        helperObj.ID = helper.get('ID').value;
        helperObj.Note = helper.get('Note').value;
        helperObj.UserID = helper.get('HelperId').value;

        let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
        let helperCodeTypeID: string = appointmentTypes.find(x => x.Code == 'Helper').ID;
        helperObj.AppointmentTypeID = helperCodeTypeID;

        let objStartTime = helper.get('StartTime').value;

        helperObj.AppointmentDate = this.datePipe.transform(new Date(helper.get('Date').value), "MM/dd/yyyy");
        helperObj.StartTime = new Date(
          helper.get('Date').value.toDateString("MM/dd/yyyy") +
          " " +
          objStartTime.getHours() + ":" + objStartTime.getMinutes() + ":" + objStartTime.getSeconds()
        )
          .toTimeString()
          .split(" ")[0];

        let objEndTime = new Date(objStartTime);
        let duration = parseInt(helper.get('DurationHour').value) * 60 + parseInt(helper.get('DurationMin').value);
        objEndTime.setMinutes(objStartTime.getMinutes() + duration);
        helperObj.EndTime = new Date(
          helper.get('Date').value.toDateString("MM/dd/yyyy") +
          " " +
          objEndTime.getHours() + ":" + objEndTime.getMinutes() + ":" + objEndTime.getSeconds()
        )
          .toTimeString()
          .split(" ")[0];
        helperObj.IsDirty = helper.dirty;
        helperObj.ModifyDate = helper.get('ModifyDate').value;
        helperObj.IsSchedule = helper.get('autoschedule').value;
        if (!showHelperToast && helperObj.IsSchedule)
          showHelperToast = true;
        appointments.push(helperObj);
      }
    });

    submitModel.AssignedTechnicians = appointments;

    this.selectedItems.forEach(x => {
      let WorkTicketPriceBookItem: any = {};
      WorkTicketPriceBookItem.PriceBookItem = x;
      WorkTicketPriceBookItem.WorkTicketPriceBookLinkingId =
        x.WorkTicketPriceBookLinkingId;
      WorkTicketPriceBookItem.ID =
        x.parentID == undefined ? "" : x.parentID;
      WorkTicketPriceBookItem.IsDirty = true;
      WorkTicketPriceBookItem.PriceBucket = this.bucket;
      WorkTicketPriceBookItem.Quantity = x.Quantity;
      WorkTicketPriceBookItem.IsTaxable = x.IsTaxable;
      WorkTicketPriceBookItem.Price = (x.AgreementPrice != null && x.AgreementPrice == x.Price)? x.OriginalPrice : x.Price;
      WorkTicketPriceBookItem.AgreementPrice = x.AgreementPrice;
      WorkTicketPriceBookItem.ServiceAgreement = !FsUtil.checkNullOrUndefined([x.ServiceAgreementID], true)? { ID: x.ServiceAgreementID } : null;
      WorkTicketPriceBookItem.OriginalPrice = x.OriginalPrice;

      if (x.AccountingCode == undefined || x.AccountingCode == "")
        WorkTicketPriceBookItem.PriceBookAccountingCode = null;
      else WorkTicketPriceBookItem.PriceBookAccountingCode = x.AccountingCode;
      //if (element.IsDescriptionEditAllowed)
      WorkTicketPriceBookItem.Description = x.Description;
      WorkTicketPriceBookItem.Note = x.Note;
      WorkTicketPriceBookItem.Status = x.Status;
      WorkTicketPriceBookItem.LineCounter = x.LineCounter;
      if (x.WorkStatus == undefined || x.WorkStatus == "")
        WorkTicketPriceBookItem.WorkStatus = null;
      else WorkTicketPriceBookItem.WorkStatus = x.WorkStatus;

      let equipments: WorkTicketPriceBookItemEquipment[] = [];
      x.WorkTicketPriceBookItemEquipments.forEach(x => {
        if (x.ID == "")
          x.ID = CommonMethods.GetID();
        x.JobSiteEquipmentID = x.JobSiteEquipment.ID;
        x.WorkticketPriceBookItemID = x.parentID == undefined ? CommonMethods.GetID() : x.parentID;
        equipments.push(x);
      });
      WorkTicketPriceBookItem.WorkTicketPriceBookItemEquipments = x.WorkTicketPriceBookItemEquipments;
      submitModel.WorkTicketPriceBookItems.push(WorkTicketPriceBookItem);
    });
    if (!this.selectedDiscount.IsDeleted)
      submitModel.WorkTicketDiscountItems.push(this.selectedDiscount);
    else submitModel.WorkTicketDiscountItems = [];
    submitModel.WorkTicketPayment = new WorkTicketPayment();
    submitModel.WorkTicketPayment.WorkTicketPaidDetails =
      this.Details.WorkTicketPayment != null
        ? this.Details.WorkTicketPayment.WorkTicketPaidDetails
        : [];
    submitModel.WorkTicketPayment.InvoiceComment = this.editWorkTicketForm.controls[
      "InvoiceComment"
    ].value;
    submitModel.WorkTicketPayment.TaxGroup = this.wtSelectedTaxGroup;
    submitModel.ID = this.Details.ID;
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
    this.httpService.EditWorkOrder(submitModel).subscribe(
      response => {
        if (
          $(this._elementRef.nativeElement)
            .find(".tabs__content__box")
            .hasClass("dirty")
        ) {
          $(this._elementRef.nativeElement)
            .find(".tabs__content__box")
            .removeClass("dirty");
        }
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        setTimeout(() => {
          if (this.destroyTab) {
            this.tabOpen.DestroyTab(this.tabCounter);
          } else {
            this.tabOpen.ReplaceTab(
              {
                CurrentTabIndex: this.tabCounter,
                newTabInfo: {
                  tabId: Tabs.FsLiteWorkOrderView,
                  params: {
                    ID: submitModel.ID,
                    jobsiteId: submitModel.JobSite.ID,
                    customerId: submitModel.Customer.ID,
                    activeSubTabIndex: this.subTabs.filter(x => x.Selected==true)[0].Index
                  },
                  tabTitle: this.Details.WorkTicketNo
                }
              },
              false
            );
          }
        }, 300);

        let successMessage = showHelperToast ? "Success Helper Appointment(s) dispatched successfully" : "Work Order " + this.Details.WorkTicketNo + " updated";
        this.toastr.success(successMessage, "Success!");
      },
      error => {
        this.destroyTab = false;
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
  }

  public SetTaxGroup(event) {
    let val = $(event.target).val();
    if (val != "") {
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
      let subscription = this.httpService
        .getTaxGroup(val)
        .subscribe(response => {
          let selectedTaxGroup: any = this.taxGroups.filter(x => x.ID == val);
          if (!CommonMethods.CheckNullOrUndefined(selectedTaxGroup)) {
            if (selectedTaxGroup.length > 0) {
              this.selectedTaxGroup = selectedTaxGroup[0];
              this.selectedTaxGroup.TaxCodes = response.TaxCodes;
            }
          }
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        });
      this.subscriptions.push(subscription);
    } else {
      this.selectedTaxGroup = null;
    }
  }

  public ApplyTaxGroup() {
    if (!CommonMethods.CheckNullOrUndefined(this.selectedTaxGroup)) {
      this.wtSelectedTaxGroup = this.selectedTaxGroup;
      this.editWorkTicketForm.markAsDirty();
      this.ApplyDiscountAndTaxRate();
      this.selectedTaxGroup = null;
      this.taxEditorPopup = false;
    } else {
      this.toastr.error("Tax Group is required, please select one.", "Error");
    }
  }

  public AddNewRow(index) {
    (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
      .at(index)
      .get("PromisedDate")
      .setValidators(Validators.required);
    if (
      (<FormArray>this.editWorkTicketForm.controls["AssignedTechnicians"])
        .length ==
      index + 1
    ) {
      const formArr = <FormArray>(
        this.editWorkTicketForm.controls["AssignedTechnicians"]
      );
      formArr.push(this.InitAssignedTechnician(null));
    }
  }

  public SetCurrentTechnicianIndexToRemove(index: number) {
    this.currentRemoveTechIndex = index;
    this.showDeleteTechConfirmation = true;
  }

  public CancelDeleteTech() {
    this.currentRemoveTechIndex = null;
    this.showDeleteTechConfirmation = false;
  }
  public RemoveTechnician() {
    let index = this.currentRemoveTechIndex;
    const formArr = <FormArray>(
      this.editWorkTicketForm.controls["AssignedTechnicians"]
    );
    if (index != null) {
      if (formArr.controls[index] instanceof FormGroup) {
        let tech = <FormGroup>formArr.controls[index];
        if (tech.controls["IsPrimary"].value == true) {
          // this.editWorkTicketForm.controls["PrimaryTechnician"].setValue("");
          this.editWorkTicketForm.controls["OwnerUser"].setValue("");
        }
      }
      formArr.removeAt(index);
      this.currentRemoveTechIndex = null;
      this.showDeleteTechConfirmation = false;
    }
  }
  public GetAssignedTechnicians() {
    const formArr = <FormArray>(
      this.editWorkTicketForm.controls["AssignedTechnicians"]
    );
    return formArr.controls;
  }
  public Toggle__collapse(trg, event) {
    if (event != null) {
      if ($(event.target).hasClass("newAttachment")) {
        return;
      }
    }
    var parent = $(trg);
    parent.toggleClass("hidden");
    parent.find(".collapse__box__body").slideToggle();
  }
  public OnTabSelect(index) {
    if (index==2) this.InitSlider();
  }
  public ItemDropDownBlur() {
    this.searchString = "";
    this.itemDropDownFilteredVals = [];
  }
  public ItemDropdownFilterAPI(value) {
    if (value != undefined && value.trim() != "" && value.length > 2) {
      value = value.toLowerCase().trim();
      this.searchString = value;
      this.showspinner.showloader(this.MIDropDown, this.tabCounter, Constants.defaultSpinnertimeout, true, this.itemDropDownFilteredVals.length, LoaderType.circle, [{ "class": "sm-size ps-relative" }]);
      this.itemSearchTerm$.next(value);
    } else {
      this.searchString = "";
      this.showspinner.hideLoader(this.MIDropDown, this.tabCounter);
      this.itemDropDownFilteredVals = [];
    }
  }
  public GetHighlightedString(name: string) {
    let index = name.toUpperCase().indexOf(this.searchString.toUpperCase());
    if (index == -1) {
      return "";
    }
    let length = this.searchString.length;
    return name.substring(index, index + length);
  }
  public GetStringRightPart(name: string) {
    let index = name.toUpperCase().indexOf(this.searchString.toUpperCase());
    let length = this.searchString.length;
    if (index == -1 || length == 0) {
      return name;
    }

    return name.substring(index + length, name.length);
  }
  public GetStringLeftPart(name: string) {
    let index = name.toUpperCase().indexOf(this.searchString.toUpperCase());
    if (this.searchString.length == 0) return "";
    return name.substring(0, index);
  }  
  private ToWorkTicketDiscountModel(item) {
    let model = new WorkTicketDiscountItem();
    model.ID = item.ID;
    model.Name = item.Name;
    model.DiscountType = item.DiscountType;
    let discountModel = new Discount();
    discountModel.ID = item.Discount.ID;
    discountModel.Name = item.Discount.Name;
    discountModel.Amount = !CommonMethods.CheckNullOrUndefined(item.Rate)
      ? item.Rate
      : 0;
    discountModel.IsAmountEditable = item.Discount.IsAmountEditable;
    discountModel.IsNameEditable = item.Discount.IsNameEditable;
    model.Discount = discountModel;
    model.Rate = !CommonMethods.CheckNullOrUndefined(item.Rate)
      ? item.Rate
      : 0;
    return model;
  }
  public FilterValue(target) {
    if (target.keyCode == 109 || target.keyCode == 189) {
      target.preventDefault();
      target.stopPropagation();
    }
  }
  public handleTechnicianFilter(value) {
    let filteredList = this.technicians.filter((s) => `${s.FirstName} ${s.LastName}`.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    this.setKendoTechData(filteredList);
  }
  public setKendoTechData(list) {
    this.techniciansData = [];
    let _this = this;
    _this.techniciansData.push({ name: "Select Technician", id: "", department: "" });
    list.forEach(function (item) {
      if (item.Department != null) {
        _this.techniciansData.push({ name: item.FirstName + ' ' + item.LastName, id: item.ID, department: item.Department.Name });
        _this.techGroupedData = groupBy(_this.techniciansData, [{ field: "department" }]);
      }
    });
  }
  public OpenAttachment() {
    this.kendoUploadFileList = [];
    this.modalOptions.showAttachment = true;
    this.attachmentType = "Image";
    this.IntializeAttachmentForm();
  }
  private IntializeAttachmentForm(item = null) {
    if (item != null) {
      this.attachmentForm = this.frmbuilder.group({
        ID: new FormControl(item.ID),
        Uid: new FormControl(item.Uid),
        FileName: new FormControl(item.FileName, [
          Validators.required,
          this.commonMethods.noWhitespaceValidator,
          Validators.maxLength(50)
        ]),
        Description: new FormControl("", Validators.maxLength(1024)),
        ImagePath: new FormControl(item.FilePath == null ? "" : item.FilePath)
      });
    } else {
      this.attachmentForm = this.frmbuilder.group({
        ID: new FormControl(""),
        FileName: new FormControl("", [
          Validators.required,
          this.commonMethods.noWhitespaceValidator,
          Validators.maxLength(50)
        ]),
        ImagePath: new FormControl(""),
        Description: new FormControl("", Validators.maxLength(1024))
      });
    }
  }
  public UploadEventHandler(e: UploadEvent) {
    this.isUploadInProgress = true;
  }

  public CancelEventHandler(e: CancelEvent) {
    this.isUploadInProgress = false;
  }

  public RemoveEventHandler(e: RemoveEvent) {
    const index = this.kendoUploadFileList.indexOf(
      this.kendoUploadFileList.find(x => x.fileInfo.uid == e.files[0].uid)
    );
    if (index > -1) {
      this.kendoUploadFileList.splice(index, 1);
    }
  }

  public SuccessEventHandler(e: SuccessEvent) {
    if (e.operation == "upload") {
      let fileInfo = e.response.body[0];
      var info = new KendoUploadFileInfo();

      info.fileInfo = e.files[0];
      info.attachmentInfo = new Attachment();
      info.attachmentInfo.FileName = e.files[0]["name"];
      info.attachmentInfo.FilePath = fileInfo.StorageLocation;
      if (this.kendoUploadFileList.length > 0 && this.kendoUploadFileList.find(x => x.attachmentInfo.FileName == info.attachmentInfo.FileName) != undefined) {
        e.preventDefault();
        this.toastr.error(
          "This file has already been attached, Please rename and try again."
        );
      }
      else {
        this.kendoUploadFileList.push(info);
      }

      this.isUploadInProgress = false;
    }
  }

  public ErrorEventHandler(e: any) {
    if (e.response != null) {
      this.toastr.showMultiLineError(e.response.error.Message, "Error");
    } else {
      this.toastr.showMultiLineError("Something went wrong!", "Error");
    }
    this.isUploadInProgress = false;
  }
  public async AddAttachment() {
    var totalCount = this.attachments.total;
    /* New attachment */
    let fileDescription = this.attachmentForm.controls["Description"].value;
    if (this.attachmentType == "Image") {
      this.kendoUploadFileList.forEach(x => {
        var attachment = x.attachmentInfo;
        var fileInfo = x.fileInfo;
        attachment.Description = fileDescription;
        attachment.IsDirty = false;
        this.attachments.data.push({
          'FileName': x.attachmentInfo.FileName,
          'FilePath': x.attachmentInfo.FilePath,
          'Description': x.attachmentInfo.Description,
          'IsDirty': false,
          'IsImage': this.CheckIsImage(x.attachmentInfo),
          'Uid': fileInfo.uid
        });
        totalCount++;
      });
      this.CloseModal("Attachment");
      this.attachments.total = totalCount;
    }
  }
  private GetWorkOrderDocumentsAndImages(workOrderAttachments: any) {
    if (workOrderAttachments != null) {
      this.attachments.data = workOrderAttachments.map(x => {
        return {
          FilePath: x.FilePath,
          Description: x.Description,
          FileName: x.FileName,
          IsImage: this.CheckIsImage(x),
          ID: x.ID,
          IsDirty: x.IsDirty,
          UploadedDate: x.CreateDate,
          UploadedBy: x.CreatedByUser
        }
      });
      this.attachments.total = this.attachments.data.length;
    }
  }
  private CheckIsImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        return this.commonMethods.ValidExtension(fileName, exts);
      }
      else
        return false;
    }
    else
      return false;
  }

  public CloseModal(type) {
    if (type == "Attachment") {
      if (this.attachmentForm.dirty) {
        //  this.tabOpen.DestroyTab(this.tabCounter, "modal")
        this.modalOptions.showAttachment = false;
      } else {
        this.modalOptions.showAttachment = false;
      }
    }
    if ((type = "EditAttachment")) {
      //  this.tabOpen.DestroyTab(this.tabCounter, "modal")
      this.isEditAttachment = false;
    }
  }
  /** used for attachment slider */
  ViewAttachmentSlide(idx: number) {
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }

  /** used for attachment slider */
  CloseAttachmentSlider() {
    this.showAttachmentSlider = false;
  }
  public OpenEdit(dataItem) {
    this.IntializeEditAttachment(dataItem);
    this.isEditAttachment = true;
  }
  private IntializeEditAttachment(item = null) {
    this.attachmentType = item.IsImage;
    this.editAttachmentForm = this.frmbuilder.group({
      ID: new FormControl(item.ID),
      Description: new FormControl(item.Description),
      ImagePath: new FormControl(item.FilePath),
      FileName: new FormControl(item.FileName),
      IsImage: new FormControl(item.IsImage),
      Uid: new FormControl(item.Uid)
    });

    if (item.FilePath != "" && item.FilePath != null) {
      setTimeout(() => {
        if (item.IsImage)
          $(this.attachImagePreview.nativeElement).show();
      }, 100);
    }
  }
  public Delete(dataItem) {
    this.deleteDataItem = dataItem;
    this.showDeleteConfirmation = true;
    if (this.attachments.data.findIndex(x => x.ID == dataItem.ID) > -1) {
      this.deleteMessage = "This action will permanently delete the record.";
    }
  }

  public ConfirmDelete(ref) {
    this.showDeleteConfirmation = false;
    if (ref) {
      let dataItem = this.deleteDataItem;
      if (dataItem.ID == null || dataItem.ID == "") {
        this.attachments.data.splice(
          this.attachments.data.findIndex(x => x.Uid == dataItem.Uid),
          1
        );
      } else {
        this.attachments.data.splice(
          this.attachments.data.findIndex(x => x.ID == dataItem.ID),
          1
        );
      }
    } else {
      this.deleteDataItem = null;
    }
  }
  public ConfirmModify(ref) {
    if (ref) {
      this.showModifyConfirmation =false;
      this.isPriceBookWorkItemModified =false;
      this.SubmitForm();
    } else {
      this.showModifyConfirmation = false;
    }
  }
  public async EditDocument() {
    let currentID = this.editAttachmentForm.controls["ID"].value;
    let currentUid = this.editAttachmentForm.controls["Uid"].value;
    let updatedDescription = this.editAttachmentForm.controls["Description"].value;
    if (this.attachments.data.find(x => currentID != null && currentID != "" && x.ID == currentID) != undefined
      || this.attachments.data.find(x => x.Uid == currentUid) != undefined) {
      var idx = this.attachments.data.findIndex(x => (currentID != null && currentID != "" && x.ID == currentID)
        || ((currentID == null || currentID == "") && x.Uid == currentUid));
      const exisitingItem = this.attachments.data[idx];
      if (exisitingItem["Description"] != updatedDescription && !CommonMethods.CheckNullOrUndefined(updatedDescription)) {
        exisitingItem["Description"] = updatedDescription;
        exisitingItem["IsDirty"] = true;
        this.attachments.data[idx] = exisitingItem;
      }
    }
    this.CloseModal("EditAttachment");
  }

  public ValidateScheduledTime(): boolean {
    let editticketForm = Object.assign({}, this.editWorkTicketForm.get('PrimaryTechnician').value);
    let objStartTime: Date;
    let objEndTime: Date;
    if (editticketForm.ScheduleType == "1" && editticketForm.StartTime) {
      objStartTime = editticketForm.StartTime;
      objEndTime = new Date(objStartTime);
    }
    else {
      objStartTime = new Date();
      objStartTime.setMinutes(0);
      objStartTime.setHours(0);
      objStartTime.setSeconds(0);
      objEndTime = new Date(objStartTime);
    }
    let duration = parseInt(editticketForm.DurationHour) * 60 + parseInt(editticketForm.DurationMin);
    objEndTime.setMinutes(objStartTime.getMinutes() + duration);
    let maxEndTime = new Date(objStartTime);
    maxEndTime.setMinutes(59);
    maxEndTime.setHours(23);
    maxEndTime.setSeconds(0);
    if (objEndTime > maxEndTime) {
      this.toastr.error(
        "Work order must be assigned in the same day."
      );
      return false;
    }
    else if (objEndTime <= objStartTime) {
      this.toastr.error(
        "The end time should always be greater than start time for all assigned technicians."
      );
      return false;
    }
    return true;
  }

  public ItemSelectionChanged(eventData) {
    this.editWorkTicketForm.markAsDirty();
  }
  // #endregion

  //#region Helpers
  public UpdateHelpers(helperRow)
  {
    this.HelpersForm.push(helperRow);
  }

  public RemoveHelper(val) {
    this.HelpersForm.removeAt(val);
    this.HelpersForm.updateValueAndValidity();
  }

  private EventOneDayTimeValidator(control: FormControl): any {
    if (
      control != undefined &&
      control.parent != undefined &&
      control.parent.parent != undefined &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["StartTime"].value) && control.parent.controls["StartTime"].value.toString() != "" &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["DurationHour"].value) && control.parent.controls["DurationHour"].value.toString() != "" &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["DurationMin"].value) && control.parent.controls["DurationMin"].value.toString() != "" &&
      control.value && control.parent.get('Dirty').value == true &&
      (!CommonMethods.CheckNullOrUndefined(control.parent.parent.controls['ScheduleType'])) && control.parent.parent.controls['ScheduleType'].value == '1'
    ) {
      let objStartTime = control.parent.controls["StartTime"].value;
      let DurationMin = isNaN(control.parent.controls["DurationMin"].value) ? 0 : control.parent.controls["DurationMin"].value;
      DurationMin = parseInt(DurationMin) > 0 ? 30 : DurationMin; // Either 0 or 30
      let DurationHour = isNaN(control.parent.controls["DurationHour"].value) ? 0 : control.parent.controls["DurationHour"].value;
      let objEndTime = new Date((new Date(objStartTime).getTime() + (((parseInt(DurationHour) * 60) + parseInt(DurationMin)) * 60000)));
      if (objStartTime == null && objEndTime == null) {
        return null;
      } else {
        let startTime = objStartTime;
        let endTime = new Date(objEndTime);
        //endTime.setMinutes(endTime.getMinutes() - 1); // to handle next day 12 a.m. as per scheduler
        if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
          new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
          new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
          return null;
        }
        else {
          return { InvalidOneDayTime: true };
        }
      }
    }
    return null;
  }
  private EventOneDayTimeValidatorForHelper(control: FormControl): any {
    if (
      control != undefined &&
      control.parent != undefined &&
      control.parent.parent != undefined &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["StartTime"].value) && control.parent.controls["StartTime"].value.toString() != "" &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["DurationHour"].value) && control.parent.controls["DurationHour"].value.toString() != "" &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["DurationMin"].value) && control.parent.controls["DurationMin"].value.toString() != "" &&
      control.value && control.parent.get('Dirty').value == true
    ) {
      let objStartTime = control.parent.controls["StartTime"].value;
      let DurationMin = isNaN(control.parent.controls["DurationMin"].value) ? 0 : control.parent.controls["DurationMin"].value;
      DurationMin = parseInt(DurationMin) > 0 ? 30 : DurationMin; // Either 0 or 30
      let DurationHour = isNaN(control.parent.controls["DurationHour"].value) ? 0 : control.parent.controls["DurationHour"].value;
      let objEndTime = new Date((new Date(objStartTime).getTime() + (((parseInt(DurationHour) * 60) + parseInt(DurationMin)) * 60000)));
      if (objStartTime == null && objEndTime == null) {
        return null;
      } else {
        let startTime = objStartTime;
        let endTime = new Date(objEndTime);
        //endTime.setMinutes(endTime.getMinutes() - 1); // to handle next day 12 a.m. as per scheduler
        if (new Date(startTime).getDate() == new Date(endTime).getDate() &&
          new Date(startTime).getMonth() == new Date(endTime).getMonth() &&
          new Date(startTime).getFullYear() == new Date(endTime).getFullYear()) {
          return null;
        }
        else {
          return { InvalidOneDayTime: true };
        }
      }
    }
    return null;
  }
  private DurationValidator(control: FormControl): any {
    if (
      control != undefined &&
      control.parent != undefined &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["DurationHour"].value) && control.parent.controls["DurationHour"].value.toString() != "" &&
      !CommonMethods.CheckNullOrUndefined(control.parent.controls["DurationMin"].value) && control.parent.controls["DurationMin"].value.toString() != "" &&
      control.value && control.parent.get('Dirty').value == true
    ) {
      let hour: any = control.parent.controls["DurationHour"].value;
      let minutes: any = control.parent.controls["DurationMin"].value;
      if (!isNaN(hour) && !isNaN(minutes)) {
        if (parseInt(hour) <= 0 && parseInt(minutes) <= 0) {
          return { InvalidHourMinute: true };
        }
        else {
          return null;
        }
      }
    }
  }
  private CustomDateValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value !== undefined && control.parent != undefined && control.parent.get('Dirty').value == true && isNaN(Date.parse(control.value)) == true) {
      return { DateError: true };
    }
    return null;
  }
  ValidateHelperId(control: AbstractControl): { [key: string]: any } | null {
    if (control != undefined && control.parent != undefined) {
      if (control.value && control.parent.get('Dirty').value == true && control.value == '') {
        return Validators.required;
      }
    }
    return null;
  }


  lblPTDurationValidationError: string = '';
  lblHelperDurationValidationError: string = '';
  public updateformValidation(FormGroupName: string, dataItem: FormGroup = null) {
    if (FormGroupName == 'PrimaryTechnician') {
      Object.keys(this.editWorkTicketForm.controls[FormGroupName].value).forEach(key => {
        this.editWorkTicketForm.get(FormGroupName + '.' + key).updateValueAndValidity();
      });
      this.DurationValidationError(FormGroupName, null); // to print validation error related to hour or minute
    }
    else if (FormGroupName == 'AssignedHelpers') {
      Object.keys(dataItem.value).forEach(key => {
        dataItem.get(key).updateValueAndValidity();
      });
      this.DurationValidationError(FormGroupName, dataItem); // to print validation error related to hour or minute
    }
  }
  public DurationValidationError(FormGroupName: string, dataItem: FormGroup) {
    let validationError: string = '';

    let DurationHour: FormControl = FormGroupName == 'PrimaryTechnician' ? <FormControl>this.editWorkTicketForm.get(FormGroupName + '.DurationHour')
      : <FormControl>dataItem.get('DurationHour');
    let DurationMin: FormControl = FormGroupName == 'PrimaryTechnician' ? <FormControl>this.editWorkTicketForm.get(FormGroupName + '.DurationMin')
      : <FormControl>dataItem.get('DurationMin');

    if (DurationHour.hasError('required') && DurationMin.hasError('required')) {
      validationError = "Hour is required field Minute is required field";
    }
    else if (DurationHour.hasError('required') && !DurationMin.hasError('required')) {
      validationError = "Hour is required field";
    }
    else if (!DurationHour.hasError('required') && DurationMin.hasError('required')) {
      validationError = "Minute is required field";
    }
    else if (DurationHour.hasError('pattern') && DurationMin.hasError('pattern')) {
      validationError = "Hour should be between 0-23 Minute should be 0 or 30";
    }
    else if (DurationHour.hasError('pattern') && !DurationMin.hasError('pattern')) {
      validationError = "Hour should be between 0-23";
    }
    else if (!DurationHour.hasError('pattern') && DurationMin.hasError('pattern')) {
      validationError = "Minute should be 0 or 30";
    }
    else if (DurationHour.hasError('InvalidOneDayTime') || DurationMin.hasError('InvalidOneDayTime')) {
      validationError = "Events cannot be scheduled more than 1 calender day";
    }
    else if (DurationHour.hasError('InvalidHourMinute') || DurationMin.hasError('InvalidHourMinute')) {
      validationError = "Duration cannot be 0 hour and 0 minute";
    }
    if (FormGroupName == 'PrimaryTechnician') {
      this.lblPTDurationValidationError = validationError;
    }
    else {
      this.lblHelperDurationValidationError = validationError;
    }
  }
  private setAgreementDiscount() {
    let totalAgreementPrice = 0;
    let totalStandardPrice = 0;

    this.selectedItems.forEach(x => {
      if (x.AgreementPrice != null && x.AgreementPrice == x.Price) {
        totalAgreementPrice += (x.Quantity * x.AgreementPrice);     
        totalStandardPrice += (x.Quantity * x.OriginalPrice);
      }
    });
    this.agreementDiscount = totalStandardPrice - totalAgreementPrice;
  }
  private checkIsUsedToOverridePrice() {
    const pricebookIds = this.selectedItems.map(x => x.ID);
    const id = (this.activeAgreement)? this.Details.JobSite.ID : null;
    this.httpService
    .GetPricingForItems(this.state, "", id, pricebookIds, this.overrideItemIds)
    .subscribe(res => {
      this.selectedItems.forEach(x => {
        const item = res.Data.find(y => y.ID === x.ID);
        if (item) {
          x.Price = (item.AgreementPrice)? item.AgreementPrice : item.StandardPrice;
          x.AgreementPrice = item.AgreementPrice;
        }
      });
      this.recalculateSpinner = false;
      this.GetAPBItems();
      this.ApplyDiscountAndTaxRate(); 
    }, (error) => {
      this.recalculateSpinner = false;
    });
  }
  //#endregion
}
